export async function controlCarouselVideosPlayback(
  index: number,
  videoDomRefs: Record<string, HTMLVideoElement | null>,
) {
  // @NOTE: pause all videos
  for (const key in videoDomRefs) {
    try {
      videoDomRefs[key]?.pause();
    } catch (err) {
      // @NOTE: dont think we need to care about errors which
      // could happen here, just swallow and move on
    }
  }
  // @NOTE: play just the currently active video
  try {
    await videoDomRefs[`slide-${index}-video`]?.play();
  } catch (err) {
    // @NOTE: dont think we need to care about errors which
    // could happen here, just swallow and move on
  }
}
